import axios from 'axios';

export default {
  async index({
    preUrl,
    parentName = null,
    parentId = null,
    modelName,
    params,
    pagination = true,
    endpoint = window.API_BASE_URL && window.API_BASE_URL.data !== undefined && window.API_BASE_URL.data !== '' ? window.API_BASE_URL.data : process.env.VUE_APP_API_BASE_URL,
  }) {
    let url = '';
    if (endpoint) {
      url += `${endpoint}/`;
    }
    if (preUrl) {
      url += `${preUrl}/`;
    }
    if (parentName) {
      url += `${parentName}/${parentId}/`;
    }
    if (modelName) {
      url += `${modelName}`;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(url, {
          params: {
            ...axios.defaults.params,
            ...params
          },
        })
        .then((res) => {
          if (pagination) {
            resolve(res.data);
          } else {
            resolve(res.data.data);
          }
        })
        .catch((err) => {
          reject(err);
          console.error(`${modelName} index error`);
        });
    });
  },
};
